import { render, staticRenderFns } from "./VPopoverActions.vue?vue&type=template&id=390ace3c&"
import script from "./VPopoverActions.vue?vue&type=script&lang=js&"
export * from "./VPopoverActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports